module.exports = __webpack_public_path__ + "static/media/final_06.7d8f335f.jpg";